import { render, staticRenderFns } from "./MessagesForSubmission.vue?vue&type=template&id=4395e15d&"
import script from "./MessagesForSubmission.vue?vue&type=script&lang=js&"
export * from "./MessagesForSubmission.vue?vue&type=script&lang=js&"
import style0 from "./MessagesForSubmission.vue?vue&type=style&index=0&id=4395e15d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports